/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCheckboxCrossed = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2.222 0A2.222 2.222 0 0 0 0 2.222v19.556C0 23.005.995 24 2.222 24h19.556A2.222 2.222 0 0 0 24 21.778V2.222A2.222 2.222 0 0 0 21.778 0H2.222zM12 10.586 3.414 2h17.172L12 10.586zM10.586 12 2 20.586V3.414L10.586 12zM3.414 22 12 13.414 20.586 22H3.414zm10-10L22 3.414v17.172L13.414 12z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCheckboxCrossed as CheckboxCrossed };
